import { useMutation } from '@tanstack/react-query';
import type AgentApiAiJobSearchRunsResult from '@/types/serializers/AgentApiAiJobSearchRunsResult';
import useBulkJobPosts from '../../hooks/useBulkJobPosts';
import useSuggestSharedJobPosts from '../../hooks/useSuggestSharedJobPosts';

/** AI推薦結果を自社求人・求人DBに振り分けて候補者へ提案する */
export default function useSuggestAiRecommendations(candidateProfileId: number) {
  const bulkJobPosts = useBulkJobPosts(candidateProfileId);
  const suggestShared = useSuggestSharedJobPosts(candidateProfileId);

  return useMutation({
    mutationFn: async (results: AgentApiAiJobSearchRunsResult[]) => {
      const providedIds = results.flatMap((r) =>
        r.source === 'provided' && r.provided_job_post_id !== null ? [r.provided_job_post_id] : []
      );
      const sharedIds = results.flatMap((r) =>
        r.source === 'shared' && r.shared_job_post_id !== null ? [r.shared_job_post_id] : []
      );

      const tasks: Promise<unknown>[] = [];
      if (providedIds.length > 0) {
        tasks.push(bulkJobPosts.mutateAsync({ provided_job_post_ids: providedIds }));
      }
      if (sharedIds.length > 0) {
        tasks.push(suggestShared.mutateAsync({ shared_job_post_ids: sharedIds }));
      }
      const settled = await Promise.allSettled(tasks);
      const failed = settled.find((s) => s.status === 'rejected');
      if (failed && failed.status === 'rejected') throw failed.reason;
    },
  });
}
